<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-pencil-square-o mr-5"></i>{{'create-new-labels' | translate}}</h2>
      </div>
      <div class="box-body">
      <div class="col-xs-12">
        <div class="row">
          <div class="form-group col-xs-12">
            <label class="pull-left">{{'adress_type' | translate}}</label>
            <select class="form-control"  v-model="selectedOption">
              <option class="normal" value="home_address">{{'home_address' | translate }}</option>
              <option class="normal" value="packstation">{{ 'packstation' | translate }}</option>
              <option class="normal" value="post_store">{{'post_store' | translate }}</option>
            </select>
          </div>
        </div>
      </div>
        <div class="col-xs-12" v-if="selectedOption === 'home_address'">
        <div class="row">
          <div class="form-group col-xs-12">
            <label class="pull-left">{{'label_type' | translate}}</label>
            <select class="form-control" v-model="info.type">
              <option class="normal" value="standard">{{'label_shipping' | translate}}</option>
              <option class="normal" value="returns">{{'returns' | translate}}</option>
            </select>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-xs-12">
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'company' | translate}}*</label>
                <input class="form-control" name="company" :placeholder="'company' | translate" type="text" v-model="info.company">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'name' | translate}}*</label>
                <input v-validate="'required'" :data-vv-as="'last_name'| translate" class="form-control" name="last_name" :placeholder="'name' | translate" type="text" v-model="info.last_name">
                <span v-show="errors.has('last_name')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-9 col-xs-12">
                <label class="pull-left">{{'street' | translate}}*</label>
                <input v-validate="'required'" data-vv-as="Street" class="form-control" name="street" placeholder="Street" type="text" v-model="info.street">
                <span v-show="errors.has('street')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
              </div>
              <div class="form-group col-sm-3 col-xs-12">
                <label class="pull-left">{{'street_no' | translate}}*</label>
                <input v-validate="{required: true, regex: '^[a-zA-Z0-9 ]*$'}" :data-vv-as=" 'street_no' | translate "  :placeholder=" 'street_no' | translate " class="form-control" name="street_no"   type="text" v-model="info.street_no">
                <span v-show="errors.has('street_no')" class="small text-danger">{{ errors.first('street_no') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-3 col-xs-6">
                <label class="pull-left">{{'zip_code' | translate}}*</label>
                <input v-validate="'required'" :data-vv-as="'zip_code' | translate "  :placeholder="'zip_code' | translate "  class="form-control" name="zip_code" type="text" v-model="info.zip_code">
                <span v-show="errors.has('zip_code')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
              </div>
              <div class="form-group col-sm-6 col-xs-12">
                <label class="pull-left">{{'city' | translate}}*</label>
                <input v-validate="'required'" data-vv-as="City" class="form-control" name="city" placeholder="City" type="text" v-model="info.city">
                <span v-show="errors.has('city')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
              </div>
              <div class="form-group col-sm-3 col-xs-6">
                <label class="pull-left">{{'country' | translate}}*</label>
                <select class="form-control" v-model="info.country">
                  <option class="normal" v-for="c in Object.keys(countries)" :value="c">{{countries[c]}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-xs-12">
                <label>{{'parcel_options' | translate}}</label>
                <select class="form-control" v-model="info.parcel_id">
                  <option class="normal" v-for="opt in $store.getters.parcelOptions" :value="opt.id">{{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})</option>
                </select>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="col-xs-12" v-if="selectedOption === 'packstation'">
          <form name="packstation-form">
          <div class="row">
            <div class="form-group col-xs-12">
              <label class="pull-left">{{'label_type' | translate}}</label>
              <select class="form-control" v-model="info_for_packstation.type">
                <option class="normal" value="standard">{{'shipping' | translate}}</option>
                <option class="normal" value="returns">{{'return' | translate}}</option>
              </select>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="form-group col-xs-12">
              <label class="pull-left">{{'name' | translate}}*</label>
              <input v-validate="'required'" data-vv-as="Name" class="form-control" name="name" :placeholder="'name' | translate" type="text" v-model=" info_for_packstation.last_name">
              <span v-show="errors.has('name')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-3 col-xs-12">
              <label class="pull-left">{{'packstation' | translate}}*</label>
              <input v-validate="{ required:true }" class="form-control" name="packstation" :placeholder="'packstation'| translate" type="text" v-model=" info_for_packstation.street_no">
              <span v-show="errors.has('packstation')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
            <div class="form-group col-sm-9 col-xs-12">
              <label class="pull-left">{{'post_number' | translate}}*</label>
              <input v-validate="'required'"  class="form-control" name="post_number" :placeholder="'post_number'| translate" type="text" v-model="info_for_packstation.care_of">
              <span v-show="errors.has('post_number')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-3 col-xs-6">
              <label class="pull-left">{{'zip_code' | translate}}*</label>
              <input v-validate="'required'" class="form-control" name="zip_code_packstation" :data-vv-as="'zip_code' | translate "  :placeholder="'zip_code' | translate " type="text" v-model=" info_for_packstation.zip_code">
              <span v-show="errors.has('zip_code_packstation')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left">{{'city' | translate}}*</label>
              <input v-validate="{required: true }" class="form-control" name="city_packstation" :placeholder="'city'| translate" type="text" v-model="info_for_packstation.city">
              <span v-show="errors.has('city_packstation')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              <label class="pull-left">{{'country' | translate}}*</label>
              <select class="form-control" v-model=" info_for_packstation.country">
                <option class="normal" v-for="c in Object.keys(countries)" :value="c">{{countries[c]}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-12 col-xs-12">
              <label>{{'parcel_options' | translate}}</label>
              <select class="form-control" v-model=" info_for_packstation.parcel_id">
                <option class="normal" v-for="opt in $store.getters.parcelOptions" :value="opt.id">{{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})</option>
              </select>
            </div>
          </div>
          </form>
        </div>
        <div class="col-xs-12" v-if="selectedOption === 'post_store'">
          <div class="row">
            <div class="form-group col-xs-12">
              <label class="pull-left">{{'label_type' | translate}}</label>
              <select class="form-control" v-model="info_for_poststore.type">
                <option class="normal" value="standard">{{'shipping' | translate}}</option>
                <option class="normal" value="returns">{{'return' | translate}}</option>
              </select>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="form-group col-xs-12">
              <label class="pull-left">{{'name' | translate}}*</label>
              <input v-validate="'required'"  class="form-control" data-vv-as="Last_name_post" name="last_name_post" :placeholder="'name' | translate" type="text" v-model=" info_for_poststore.last_name">
              <span v-show="errors.has('last_name_post')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-3 col-xs-12">
              <label class="pull-left">{{'poststore' | translate}}*</label>
              <input v-validate="'required'" class="form-control" name="post-store-post-store" :placeholder="'poststore'| translate" type="text" v-model=" info_for_poststore.street_no">
              <span v-show="errors.has('post-store-post-store')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
            <div class="form-group col-sm-9 col-xs-12">
              <label class="pull-left">{{'post_number' | translate}}*</label>
              <input v-validate="'required'" class="form-control" name="post-store" :placeholder="'post_number'| translate" type="text" v-model="info_for_poststore.care_of">
              <span v-show="errors.has('post-store')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-3 col-xs-6">
              <label class="pull-left">{{'zip_code' | translate}}*</label>
              <input v-validate="'required'"  class="form-control" name="zip_code_post" :data-vv-as="'zip_code' | translate "  :placeholder="'zip_code' | translate "  type="text" v-model=" info_for_poststore.zip_code">
              <span v-show="errors.has('zip_code_post')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left">{{'city' | translate}}*</label>
              <input v-validate="'required'" data-vv-as="city_post-store" class="form-control" name="city_post-store" :placeholder="'city'| translate" type="text" v-model="info_for_poststore.city">
              <span v-show="errors.has('city_post-store')" class="small text-danger">{{ 'this_field_required' | translate }}</span>
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              <label class="pull-left">{{'country' | translate}}*</label>
              <select class="form-control" v-model=" info_for_poststore.country">
                <option class="normal" v-for="c in Object.keys(countries)" :value="c">{{countries[c]}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-12 col-xs-12">
              <label>{{'parcel_options' | translate}}</label>
              <select class="form-control" v-model=" info_for_poststore.parcel_id">
                <option class="normal" v-for="opt in $store.getters.parcelOptions" :value="opt.id">{{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <template v-if="callback.label_url && callback.label_url !== ''">
          <div class="row">
            <div class="col-xs-6">
              <div class="row">
                <div class="col-xs-12">
                  <label class="pull-left">Tracking ID: </label>
                  <span> {{callback.tracking_id}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label class="pull-left">Tracking No: </label>
                  <span> {{callback.tracking_number}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label class="pull-left">Tracking URL: </label>
                  <span><a :href="callback.tracking_url" target="_blank"> {{callback.tracking_url}}</a></span>
                </div>
              </div>
            </div>
            <div class="col-xs-3">
              <a class="btn btn-info btn-app pull-right" :href="callback.label_url" target="_blank" download="label.pdf"><i class="fa fa-cloud-download"></i>Get Label</a>
            </div>
            <div class="col-xs-3">
              <a class="btn btn-warning btn-app pull-right" href="/create-label"><i class="fa fa-retweet"></i>New Label</a>
            </div>
          </div>
        </template>
        <div v-else class="row">
          <div class="col-xs-12">
            <b-btn v-if="selectedOption === 'home_address'" :disabled="(errors.has('last_name') || errors.has('street') || errors.has('street_no') || errors.has('zip_code') || errors.has('city') )"  class="btn btn-success btn-app pull-right" type="button" @click="onClick()"><i class="fa fa-save"></i>{{'submit' | translate}}</b-btn>
            <b-btn v-if="selectedOption === 'packstation'"  :disabled="(errors.has('name') || errors.has('packstation') || errors.has('post_number') || errors.has('zip_code_packstation') || errors.has('street_no_packstation') ||  errors.has('city_packstation'))" class="btn btn-success btn-app pull-right" type="button" @click="onClick()"><i class="fa fa-save"></i>{{'submit' | translate}}</b-btn>
            <b-btn v-if="selectedOption === 'post_store'"   :disabled="(errors.has('last_name_post') || errors.has('post-store-post-store') || errors.has('post-store') || errors.has('zip_code_post') || errors.has('street_no_post_store') || errors.has('city_post-store'))" class="btn btn-success btn-app pull-right" type="button" @click="onClick()"><i class="fa fa-save"></i>{{'submit' | translate}}</b-btn>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Materials',
  data () {
    return {
      selectedOption: 'home_address',
      info: {
        type: 'standard',
        company_id: '',
        last_name: '',
        street: '',
        street_no: '',
        city: '',
        zip_code: '',
        country: 'DE',
        parcel_id: this.$store.getters.parcelId
      },
      info_for_packstation: {
        type: 'standard',
        company_id: '',
        last_name: '',
        street: 'Packstation',
        street_no: '',
        city: '',
        zip_code: '',
        country: 'DE',
        parcel_id: this.$store.getters.parcelId,
        care_of: ''
      },
      info_for_poststore: {
        type: 'standard',
        company_id: '',
        last_name: '',
        street: 'Postfiliale',
        street_no: '',
        city: '',
        zip_code: '',
        country: 'DE',
        parcel_id: this.$store.getters.parcelId,
        care_of: ''
      },
      countries: require('../../filters/countries.json'),
      callback: {
        label_url: '',
        tracking_id: '',
        tracking_url: '',
        tracking_number: ''
      },
      alerts: [],
      parcel: this.$store.getters.parcelId
    }
  },
  computed: {
  },
  methods: {
    createNewLabel (info) {
      API.post('accounting/label/create', info)
        .then(response => {
          if (response.data.status === 'error') {
            let alert = {type: 'danger', dismiss: 4, message: JSON.parse(response.data.message).errors}
            this.$store.commit('pushAlert', alert)
          } else {
            this.callback = response.data.data
            let alert = {type: 'success', dismiss: 4, message: 'Success!'}
            this.$store.commit('pushAlert', alert)
          }
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: error.response.data.message}
          this.$store.commit('pushAlert', alert)
        })
    },
    onClick () {
      this.$validator.validate()
        .then(result => {
          if (result) {
            if (this.selectedOption === 'home_address') {
              this.createNewLabel(this.info)
              this.info_for_packstation = {
                type: 'standard',
                street: 'Packstation',
                country: 'DE',
                parcel_id: this.$store.getters.parcelId
              }
              this.info_for_poststore = {
                type: 'standard',
                street: 'Postfiliale',
                country: 'DE',
                parcel_id: this.$store.getters.parcelId
              }
            }
            if (this.selectedOption === 'packstation') {
              this.createNewLabel(this.info_for_packstation)
              this.info = {
                type: 'standard',
                street: '',
                country: 'DE',
                parcel_id: this.$store.getters.parcelId
              }
              this.info_for_poststore = {
                type: 'standard',
                street: 'Postfiliale',
                country: 'DE',
                parcel_id: this.$store.getters.parcelId
              }
            }
            if (this.selectedOption === 'post_store') {
              this.createNewLabel(this.info_for_poststore)
              this.info = {
                type: 'standard',
                street: '',
                country: 'DE',
                parcel_id: this.$store.getters.parcelId
              }
              this.info_for_packstation = {
                type: 'standard',
                street: 'Packstation',
                country: 'DE',
                parcel_id: this.$store.getters.parcelId
              }
            }
          }
        })
    }
  },
  mounted () {
    this.$nextTick(function () {
    })
  }
}
</script>
<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
</style>



// WEBPACK FOOTER //
// src/components/views/NewLabels.vue